module.exports = __webpack_public_path__ + "static/media/nf.af4baec8.svg";